<template>
    <div class="button" v-bind:class="[type, classes, {'loading-button': loading, selected: selected, disabled: disabled, active: active}]" v-bind:style="[styleButton]" @click="Click($event)">
        <div class="icon fas" v-if="icon" v-bind:class="[icon]" v-bind:style="styleIcon"></div>
        <div class="label" v-bind:style="[styleLabel]" v-if="label">{{label}}</div>
        <router-link class="router-link" v-if="link" :to="link"></router-link>
        <div v-if="loading" class="fas fa-spinner loading-icon">
        </div>
    </div>
</template>

<script>
    export default {
        name: "buttonc",
        props:{
            label: [String, Number],
            icon: String,
            styleIcon: [String, Object],
            type: String,
            classes: String,
            link: Object,
            loading: Boolean,
            selected: Boolean,
            disabled: Boolean,
            active: Boolean,
            styleButton: Object,
            styleLabel: Object,
        },
        methods:{
            Click($event){
                this.$emit('click', $event);
            },
        }
    }
</script>

<style scoped>

    .button{
        display: inline-flex;
        justify-content: center;
        align-content: center;
        padding: 0 9px;
        margin: 0 5px;
        cursor: pointer;
      user-select: none;
    }

    .button > *:not(.router-link){
        pointer-events: none;
    }
    .button:not(.no-hover):hover{
        background: var(--contrast-4);
    }
    .button:not(.no-hover):hover .fas{
        color: var(--bg);
    }

    .button.green, .button.selected{
      background: #6c8d25;

      background: #323a45;
    }

    .button.green > *, .button.selected > *{
      color: white;
    }

    .button.green:not(.no-hover):hover, .button.selected:not(.no-hover):hover{
      background: #404040;
      background: #6b7c8a;
    }

    .button.red{
      background: #e5154f;
    }
    .button.red .label{
      margin-top: 0;
    }

    .button.red > *, .button.selected > *{
      color: white;
    }

    .button.red:not(.no-hover):hover, .button.selected:not(.no-hover):hover{
      background: #404040;
    }

    .button.active {
        background: #6d8d21;
        color: white;
    }

    .button.active .label {
        color: white;
    }

    .button > * {
        align-self: center;
    }

    .button .label{
        margin: 0;
    }

    .button .label:nth-child(2){
        margin-left: 4px;
    }


    .button .fas {
        position: relative;
        font-size: 17px;
        padding: 0;
        margin: 0;
        float: none;
        height: initial;
    }

    .button.square{
        width: 25px;
    }

    .button.rectangle{
        width: 50px;
    }

    .button.round{
        width: 25px;
        height: 25px;
        border-radius: 100px;
    }

    .button.round.small{
        width: 18px;
        height: 18px;
    }


    .button.no-border{
        border: none !Important;
        box-shadow: none !Important;
    }

    .button.round.small .fas{
        font-size: 12px;
    }

    .button.big{
        height: 30px;
        width: 30px;
    }

    .button.menu-shadow{
        box-shadow: 0 0 0 1.4px var(--contrast-5);

    }

    .button.big .fas{
        color: var(--contrast-5);
    }

    .button.big:not(.no-hover):hover .fas{
        color: white;
    }

    .button.big:not(.no-hover):hover{
        background: #6c8d25;
    }

    .button .fa-refresh{
        font-size: 14px;
    }
    .button.big .fa-refresh{
        font-size: 18px;
    }

    .fa-refresh:before{
        content: '\f021';
    }

    .button.loading-button > .fas:not(.loading-icon),.button.loading-button .label{
        display: none;
    }

    .loading-button .fa-spinner{
        font-size: 14px;
        color: #cccccc;
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .button.thin-label .label{
        font-family: DistrictProBook;
        font-weight: 200;
        font-size: 15px;
    }

    .button .fa-robot{
        font-size: 14px;
    }

    .button .fa-calendar-plus{
        font-size: 14px;
    }

    .fas.color-bg{
        color: var(--bg);
    }

    .button .fa-angle-down,
    .button .fa-angle-up,
    .button .fa-angle-left,
    .button .fa-angle-right{
        font-size: 22px;

    }

    .button.small .fa-angle-down,
    .button.small .fa-angle-up,
    .button.small .fa-angle-left,
    .button.small .fa-angle-right{
        font-size: 18px;

    }



    .button.block{
        height: 55px;
        width: 55px;
        border: none;
        box-shadow: none;
        background: var(--contrast-3);
        border-radius: 0;
        margin: 0;
    }

    .button.block:not(.no-hover):hover{
        background: var(--contrast-2);
    }

    .button.block.border-r::after{
        content: '';
        width: 1px;
        background: var(--contrast-1);
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        height: 30px;
    }

    .button.block .fas{
        font-size: 20px;
    }

    .button.block .fas,
    .button.block .label{
        color: var(--contrast-4);
        transform: scale(1.25);
    }

    .button.block.disabled {
        background: var(--contrast-3) !important;
        opacity: 1 !important;
    }
    .button.block.disabled .fas ,
    .button.block.disabled .label{
        color: #dbdbdb !important;
        opacity: 1 !important;

    }

    .button.block:not(.no-hover):hover .fas,
    .button.block:not(.no-hover):hover .label{
        color: var(--contrast-5);
    }

    .button.red .fas{
        color: #e5154f;
    }

    .button.block.red{
        background: #e5154f;
    }

    .button.block.red:not(.no-hover):hover{
        background: #f15985;
    }

    .button.block.red .fas,
    .button.block.red .label{
        color: #f15985;
        transform: scale(1.25);
    }

    .button.block.red:not(.no-hover):hover .fas,
    .button.block.red:not(.no-hover):hover .label{
        color: #ffb3cb;
    }

    .button.blue .fas{
        color: #2f61ac;
    }

    .button.block.blue{
        background: #2f61ac;
    }

    .button.block.blue:not(.no-hover):hover{
        background: #4076c6;
    }

    .button.block.blue .fas,
    .button.block.blue .label{
        color: #4076c6;
        transform: scale(1.25);
    }

    .button.block.blue:not(.no-hover):hover .fas,
    .button.block.blue:not(.no-hover):hover .label{
        color: #5388d8;
    }


    .button.block.green{
        background: #6c8d25;
    }

    .button.block.green:not(.no-hover):hover{
        background: #99af65;
    }

    .button.block.green .fas,
    .button.block.green .label{
        color: #99af65;
        transform: scale(1.25);
    }

    .button.block.green:not(.no-hover):hover .fas,
    .button.block.green:not(.no-hover):hover .label{
        color: #ebffb3;
    }
    .button.block.orange{
        background: #e76e13;
    }

    .button.block.orange:not(.no-hover):hover{
        background: #ec9a5c;
    }

    .button.block.orange .fas,
    .button.block.orange .label{
        color: #ec9a5c;
        transform: scale(1.25);
    }

    .button.block.orange:not(.no-hover):hover .fas,
    .button.block.orange:not(.no-hover):hover .label{
        color: #ffe2cc;
    }

    .button.block.cyan{
        background: #1e9e9a;
    }

    .button.block.cyan:not(.no-hover):hover{
        background: #25dbd5;
    }

    .button.block.cyan .fas,
    .button.block.cyan .label{
        color: #25dbd5;
        transform: scale(1.25);
    }

    .button.block.cyan:not(.no-hover):hover .fas,
    .button.block.cyan:not(.no-hover):hover .label{
        color: #ebffb3;
    }

    .button.block.lightred{
        background: #d47b7b;
    }

    .button.block.lightred:not(.no-hover):hover{
        background: #f5a2a2;
    }

    .button.block.lightred .fas,
    .button.block.lightred .label{
        color: #da9a9a;
        transform: scale(1.25);
    }

    .button.block.lightred:not(.no-hover):hover .fas,
    .button.block.lightred:not(.no-hover):hover .label{
        color: #f7cccc;
    }

    .button.block.yellow{
        background: #e5c41d;
    }

    .button.block.yellow:not(.no-hover):hover{
        background: #e5c93b;
    }

    .button.block.yellow .fas,
    .button.block.yellow .label{
        color: #ecd559;
        transform: scale(1.25);
    }

    .button.block.yellow:not(.no-hover):hover .fas,
    .button.block.yellow:not(.no-hover):hover .label{
        color: #ecdb7d;
    }


    .button .fa-undo-alt{
        transform: scaleX(-1.35) scaleY(1.35) !important;
    }

    .label-center .label{
        position: absolute;
        top: 1px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto !important;
        height: fit-content;
        width: fit-content;
    }

    .label-center .label{
        font-size: 10px;
        top: -1px;
    }

    .button.block.label-center .label{
        top: -1px;
        font-family: DistrictProBold;
        font-size: 11px;
    }

    .button.menu{
        background: transparent;
        border-radius: 0;
    }

    .button.menu:not(.no-hover):hover{
        background: var(--contrast-4);
    }

    .button.menu.active{
        background: #6d8d21;
    }

    .button.no-background{
        background: transparent;
        border-radius: 0;
    }

    .button.no-background:not(.no-hover):hover{
        background: var(--contrast-4);
    }

    .button.no-background.active{
        background: #6d8d21;
    }



    .button.square{
        border-radius: 0;
    }


    .label.space-content .button{
        margin: 0;
        padding: 0;
    }

    .button.smaller{
        font-size: 12px;
        width: 14px;
        height: 14px;
    }

    .label .button .label{
        transform: none; /* this is to prevent the offset applied to the button text to be applied to the buttons in label component icons */
        color: inherit; /* only applied to label buttons because otherwise breaks header */
    }

    .button.error .icon{
      color: var(--col-error) !important;
    }
    .button.warning .icon{
      color: var(--col-warning) !important;
    }
    .button.okay .icon{
      color: var(--col-ok) !important;
    }

    .button.input-error, .button.edit {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      z-index: 10;
      background: none;
      height: fit-content;
      pointer-events: none;
    }
    .button.edit {
      pointer-events: initial;
    }
    .button.edit {
      pointer-events: initial;
    }

    .button.input-error{
      top: 1px;
      pointer-events: initial;
      cursor: help;
    }
    .button.input-error:hover{
      background: none;
    }

    .button.input-error .icon{
      font-size: 15px;
    }


    .button.edit .icon{
      font-size: 18px;
    }

    .button.dark{
      background: #323a45;
    }
    .button.dark .label{
      color: var(--bg);
    }

    .button.icon-green-hover:hover .icon{
      color: #6c8d25;
    }

    .button.footer {
      width: 120px;
      box-shadow: none !important;
    }

    .button.footer .label{
      font-weight: 200;
      font-family: DistrictProLight;
    }


  .button.cancel.small .icon{

    margin-top: -1px;
    margin-right: 1px;
  }
</style>
